import { render, staticRenderFns } from "./EstadisticasArticulos.vue?vue&type=template&id=1454e7ec&scoped=true&lang=pug"
import script from "./EstadisticasArticulos.vue?vue&type=script&lang=js"
export * from "./EstadisticasArticulos.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasArticulos.vue?vue&type=style&index=0&id=1454e7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1454e7ec",
  null
  
)

export default component.exports